import React from 'react'

const ServicesContaineHead = (props) => {
    return (
        <>
            <div className="relative bg-white rounded-[20px] p-[23px] shadow-white transition-all duration-300 ease-in-out hover:-translate-y-[10px] hover:shadow-xl hover:bg-[#f00000] hover:text-white group hover:cursor-pointer border-red-600 border-2">
                <div className="flex flex-col items-start">
                    <div className="inline-block mb-[10px]">
                        <img
                            src={props.icon}
                            alt={props.headText}
                            className="w-16 h-16 object-contain"
                            loading="lazy"
                        />
                    </div>
                    <h3 className="text-[#f00000] text-[20px] font-medium tracking-[1px] ml-[3px] group-hover:text-white transition-colors duration-300 mb-3">
                        {props.headText}
                    </h3>
                    <p className="text-md mb-[15px] leading-[1.4] ">
                        {props.content}
                    </p>
                </div>
                <div className="absolute text-[20px] bottom-[2px] right-[5px] bg-[#f00000] text-black rounded-full p-[10px] shadow-xl hover:translate-x-[3px] hover:-translate-y-[3px] transition-all duration-300 ease-in-out hover:bg-black hover:text-white hover:rotate-[-45deg] mb-1">
                    {props.arrow}
                </div>
            </div>
        </>
    )
}

export default ServicesContaineHead
